let weburlSelect = (statu) => {
  let type
  if (statu === 0) {
    type = ''
  }
  if (statu === 1) {
    type = 'Ga'
  }
  if (statu === 2) {
    type = 'Bd'
  }
  return type
}

export default weburlSelect